import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import GenericDropdown from '@shared/components/GenericDropdown';
import SectionGrid from '@shared/components/SectionGrid';

const MinorAgesList = ({
  minors = [],
  valueKey = 'age',
  formik,
  onAgeChange,
  dropdownProps = {},
  date = 'finalizar el',
}) => {
  const ageItems = useMemo(
    () =>
      Array.from({ length: 18 }, (_, i) => {
        const age = 17 - i;
        return {
          id: age,
          fragments: [
            { text: age === 0 ? '- de 1' : age.toString(), bold: false },
          ],
        };
      }),
    []
  );

  return minors.map((minor, index) => {
    let currentAge;
    if (formik && minor.index !== undefined) {
      currentAge = formik.values.minors_ages?.[minor.index]?.age;
    } else {
      currentAge = minor[valueKey];
    }

    const selectedItem = ageItems.find(item => item.id === currentAge) || null;

    const handleSelect = item => {
      if (!item) return;

      if (formik && minor.index !== undefined) {
        formik.setFieldValue(`minors_ages[${minor.index}].age`, item.id);
      }

      if (onAgeChange) onAgeChange(item.id, index);
    };

    return (
      <SectionGrid
        key={minor.id || index}
        padding={1}
        spacing={0}
        customLayout={{
          md: {
            1: 7,
            2: 5,
          },
        }}
      >
        <Box>
          <Typography variant="subtitle1" sx={{ lineHeight: 1.2 }}>
            {`Edad del menor ${+index + 1}:`}
          </Typography>
          <Typography sx={{ fontSize: 14, color: '#000', lineHeight: 1.5 }}>
            Al {date} viaje
          </Typography>
        </Box>
        <GenericDropdown
          items={ageItems}
          selectedItem={selectedItem}
          onSelect={handleSelect}
          hasArrow
          buttonLabel=""
          centerLabel
          {...dropdownProps}
        />
      </SectionGrid>
    );
  });
};

export default MinorAgesList;
